import { IPurchaseOrder, IUserDefinedCode, SupplyChainItemType, IItemMaster, ISupplier, PurchaseItemType, IMarketValidator, IUserDefinedContact, IUser } from "@/models";

interface IJdeState {
    accountingGroups: IUserDefinedCode[];
    adhesives: IUserDefinedCode[];
    amalgams: IUserDefinedCode[];
    bottleSizes: IUserDefinedCode[];
    bottlesPerUnits: IUserDefinedCode[];
    bottlings: IUserDefinedCode[];
    brands: IUserDefinedCode[];
    brandOwners: IUserDefinedCode[];
    buyers: IUserDefinedContact[];
    capsuleQualities: IUserDefinedCode[];
    cartonExternalBoards: IUserDefinedCode[];
    cartonPrintings: IUserDefinedCode[];
    cartonTypes: IUserDefinedCode[];
    certifications: IUserDefinedCode[];
    customsTypes: IUserDefinedCode[];
    decorationTypes: IUserDefinedCode[];
    giftBoxTypes: IUserDefinedCode[];
    glassHues: IUserDefinedCode[];
    glKeys: IUserDefinedCode[];
    itemCharacteristics: any[];
    itemMasters: IItemMaster[];
    itemSupplementalData: IUserDefinedCode[];
    itemTypes: IUserDefinedCode[];
    labelTypes: IUserDefinedCode[];
    level2Classifications: IUserDefinedCode[];
    level3Classifications: IUserDefinedCode[];
    linears: IUserDefinedCode[];
    loadedPurchases: PurchaseItemType[];
    loadedSupplyChains: SupplyChainItemType[];
    mainLocations: IUserDefinedCode[];
    marketValidators: IMarketValidator[];
    masterPlanningFamilies: IUserDefinedCode[];
    materials: IUserDefinedCode[];
    measureUnits: IUserDefinedCode[];
    originCountries: IUserDefinedCode[];
    packagings: IUserDefinedCode[];
    procurementOfficers: IUserDefinedContact[];
    purchaseOrders: IPurchaseOrder[];
    purchasingFamily: IUserDefinedCode[];
    purchasingSubFamily: IUserDefinedCode[];
    qualities: IUserDefinedCode[];
    productTypes: IUserDefinedCode[];
    subMaterials: IUserDefinedCode[];
    suppliers: ISupplier[];
    userDefinedCodes: IUserDefinedCode[];
    vapCodes: IUserDefinedCode[];
    vintages: IUserDefinedCode[];
    warehouseCodes: IUserDefinedCode[];
}

const getInitialState = (): IJdeState => ({
    accountingGroups: [],
    adhesives: [],
    amalgams: [],
    bottleSizes: [],
    bottlesPerUnits: [],
    bottlings: [],
    brands: [],
    brandOwners: [],
    buyers: [],
    capsuleQualities: [],
    cartonExternalBoards: [],
    cartonPrintings: [],
    cartonTypes: [],
    certifications: [],
    customsTypes: [],
    decorationTypes: [],
    giftBoxTypes: [],
    glassHues: [],
    glKeys: [],
    itemCharacteristics: [],
    itemMasters: [],
    itemSupplementalData: [],
    itemTypes: [],
    labelTypes: [],
    level2Classifications: [],
    level3Classifications: [],
    linears: [],
    loadedPurchases: [],
    loadedSupplyChains: [],
    mainLocations: [],
    marketValidators: [],
    masterPlanningFamilies: [],
    materials: [],
    measureUnits: [],
    originCountries: [],
    packagings: [],
    procurementOfficers: [],
    productTypes: [],
    purchaseOrders: [],
    purchasingFamily: [],
    purchasingSubFamily: [],
    qualities: [],
    subMaterials: [],
    suppliers: [],
    userDefinedCodes: [],
    vapCodes: [],
    vintages:[],
    warehouseCodes: [],
});

export { IJdeState, getInitialState };
